<template>
	<Transition
		:enter-class="variantCls.enter"
		:enter-active-class="variantCls.enterActive"
		:leave-active-class="variantCls.leaveActive"
		:leave-to-class="variantCls.leaveTo"
	>
		<div
			v-if="messages && messages.length > 0"
			:class="variantCls.root"
			:style="computedStyle"
		>
			<TransitionGroup
				:enter-class="variantCls.enter"
				:enter-active-class="variantCls.enterActive"
				:leave-active-class="variantCls.leaveActive"
				:leave-to-class="variantCls.leaveTo"
			>
				<div v-for="item in computedMessages" :key="item.key">
					<div
						:key="item.key"
						:class="item.appliedCls"
						tabindex="0"
						@keypress.enter="$emit('click', item)"
						@blur="$emit('blur')"
						@focus="$emit('focus')"
					>
						<slot :content="item.content">
							<!-- Default to show the content text -->
							{{ item.content }}
						</slot>
						<div
							:class="variantCls.closeIcon"
							@click="$emit('close', item.key)"
						>
							<span>&#x2715;</span>
						</div>
					</div>
				</div>
			</TransitionGroup>
		</div>
	</Transition>
</template>

<script>
export default {
	props: {
		variant: {
			type: String,
			default: "default"
		},
		messages: {
			validator(val) {
				return val === null || Array.isArray(val)
			},
			default: () => [],
			required: false
			// example: [{ id: "unique_id", type: "neutral", text: "I am a message" }]
			// type can be: neutral, error, success, warning
		},
		max: {
			type: Number,
			default: 5,
			required: false
		},
		zIndex: {
			type: Number,
			required: false
		}
	},
	computed: {
		variantCls() {
			return this.$store.getters.variants("JMessage", this.variant).el
		},
		computedMessages() {
			return this.messages.map(item => {
				let cls = "messageNeutral"
				if (item.type === "warning") cls = "messageWarning"
				if (item.type === "error") cls = "messageError"
				if (item.type === "success") cls = "messageSuccess"
				return {
					...item,
					appliedCls: this.variantCls[cls]
				}
			})
		},
		computedStyle() {
			return this.zIndex ? `z-index: ${this.zIndex}` : ""
		}
	}
}
</script>